module.exports = __webpack_public_path__ + "static/media/iconInfo.fe7154ba.svg";